import React, { ChangeEvent } from 'react';
import { TableHead as MaterialUITableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography';
import { HeadCell } from './types';
import TableCell from './TableCell';

export interface AdditionalTableHeadProps extends Record<string, any> {
    indeterminate?: boolean;
    checked?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    isActionActive?: boolean;
}

export interface TableHeadProps<T, P> {
    headCells: Array<HeadCell<T>>;
    isFirstColumnSticky?: boolean;
    TableHeadCellComponent?: React.ComponentType<P>;
    customHeadCellProps?: AdditionalTableHeadProps;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const TableHead = <T, P>({ headCells, TableHeadCellComponent, isFirstColumnSticky, customHeadCellProps }: TableHeadProps<T, P>) => {
    const { t } = useTranslation();

    return (
        <MaterialUITableHead>
            <TableRow>
                {headCells.map((headCell, index) => {
                    const isSticky = isFirstColumnSticky && index === 0;
                    const headCellProps = {
                        ...customHeadCellProps,
                        headCell,
                        index,
                    };

                    if(TableHeadCellComponent){
                        return (
                            <React.Fragment key={headCell.id as string}>
                                {/* @ts-ignore */}
                                <TableHeadCellComponent
                                    id={headCell.id as string}
                                    align={headCell.align}
                                    {...headCellProps}
                                />
                            </React.Fragment>
                        );
                    }

                    return (
                        <TableCell
                            isTableHead
                            isSticky={isSticky}
                            id={headCell.id as string}
                            key={headCell.id as string}
                            align={headCell.align}
                        >
                            <Typography uppercase color='textSecondary' variant='caption'>{t(...headCell.label)}</Typography>
                        </TableCell>
                    );
                })}
            </TableRow>
        </MaterialUITableHead>
    );
};

export default TableHead;
